import React from 'react'
import { arrayOf, number, shape, string } from 'prop-types'
import { css } from '@emotion/core'
import { HeaderBlock, useAtSize, PersonBlock } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import getRelationshipStringKeyFromAscendancyNumber from '../../../../../shared/helpers/relationship_helper'
import { extractFourDigitYear } from '../../../../../shared/helpers/factDate_Helper'

const getPrice = (arr, year) => {
  if (arr.length !== 0 && year) {
    return (
      arr.find((item) => {
        return item?.year?.toString() === year?.toString()
      })?.textHeadline ?? ''
    )
  }
  return ''
}

export default function LineChartPanel({ gender, thumbnailIcon, person, year, showPersonBlock, yearPrices = [] }) {
  const [t] = useTranslation()
  const atSize = useAtSize()
  const birthYear = extractFourDigitYear(person?.dob)
  const age = year - birthYear
  const strType = age > 0 ? 'yearTurnedAge' : 'yearBorn'
  const yearPrice = yearPrices?.length > 0 && getPrice(yearPrices, year)

  const containerStyleStyle = css`
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
  `

  return (
    <div css={{ width: '100%', maxWidth: '400px' }}>
      {showPersonBlock && (
        <div css={{ padding: atSize({ default: '10px', lg: '20px' }) }}>
          <PersonBlock
            size={atSize({ default: 'md', lg: 'lg', xl: 'xl' })}
            avatarProps={{
              sex: gender,
              src: thumbnailIcon,
            }}
            name={`${year}`}
            details={person?.atn && t(getRelationshipStringKeyFromAscendancyNumber(person?.atn, strType), { age })}
          />
        </div>
      )}
      <div css={containerStyleStyle}>{yearPrice && <HeaderBlock heading={yearPrice} size="xl" centered />}</div>
      {!yearPrice && (
        <HeaderBlock
          heading={t('aam.no.data.for.year', "We don't have data for the selected year")}
          size="md"
          centered
        />
      )}
    </div>
  )
}

Event.propTypes = {
  yearPrices: arrayOf(
    shape({
      category: string,
      categoryId: number,
      icon: string,
      id: number,
      languageOnly: string,
      localeOnly: string,
      price: number,
      subcategory: string,
      textHeadline: string,
      textTitle: string,
      tileType: string,
      year: number,
    })
  ),
}
